import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

export const fetchENACHApplicationDetails = (fetchData: any) => {
	const data = {
		GetEnachApplicationDetailsListToken: fetchData,
	};
	const url = `${API_URL}GetEnachApplicationUploadDetails`;
	return makeApiCall(url, data);
};
export const fetchENACHUmrnUploadDetails = (fetchData: any) => {
	const data = {
		UpdateEnachUmrnDetailsListToken: fetchData,
	};
	const url = `${API_URL}UploadEnachUMRNDetails`;
	return makeApiCall(url, data);
};
export const fetchENACHPaymentUploadDetails = (fetchData: any) => {
	const data = {
		UpdateEnachPaymentDetailsListToken: fetchData,
	};
	const url = `${API_URL}UploadEnachPaymentDetails`;
	return makeApiCall(url, data);
};
